import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { DeviceComponent } from './device.component';
import { AuthGuard } from '../../auth/auth-guard.service';

const routes: Routes = [{
  path: 'liste',
  component: DeviceComponent,  canActivate: [AuthGuard],
  data: { permissions: ['adminAccess']},
  children: [

  ]

}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DeviceRoutingModule { }

export const routedComponents = [
  DeviceComponent,
];
